import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function VerifyPayment() {
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
    }, []);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#F7EBFC] px-4">
            <img src="logo.png" alt="Logo" className="max-w-[200px] w-full mb-6" />
            <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-lg w-full border border-[#E3BCF4]">
                <div className="text-sm sm:text-base text-left mb-6 text-[#652F9B]">
                    We have sent you a message on text message and email. </div>

                <div className="text-sm sm:text-base text-left mb-6 text-[#652F9B]">
                    The message contains trusted payment link to set up your £2 per month subscription.  </div>

                <div className="text-sm sm:text-base text-left mb-6 text-[#652F9B]">
                    This will verify you across all participating 18verified websites. </div>

                <div className="text-sm sm:text-base text-left mb-6 text-[#652F9B]">
                    The email will come from info@18verified.com please check your junk folder.</div>


            </div>

            <div className="mt-4 text-sm text-center text-gray-600">
                already a member?{" "}
                <a href="/verifylogin" className="text-[#740d82] hover:underline">Login Here</a>
            </div>
        </div>
    );
}
